<ion-item class="message-item" [ngClass]="{'mine-message': isMine}">

  @if (!isMine) {

    <ion-thumbnail slot="start">
      <img [src]="avatar || 'assets/img/empty-img/no_image.png'" alt=""/>
    </ion-thumbnail>

  }

  <ion-label [slot]="isMine ? 'end' : ''">

    <div class="data">
      <p class="author">{{ user }}</p>
      <p class="date-message">{{ date }}</p>
    </div>

    @if (file) {

      <div class="message-file" (click)="fileViewerManager.openFile(file)">

        @if (fileViewerManager.getFileType(file) === 'image') {

          <div class="image-wrap">
            <img [src]="file || 'assets/img/empty-img/no_image.png'" alt="">
          </div>

        } @else {

          <div class="document-wrap">
            <yu-icon color="medium" [name]="fileViewerManager.getFileIcon(file, ext)"></yu-icon>
          </div>

        }

      </div>

    }

    @if ((!message || message.trim() === '') && !file) {

      <div class="message deleted ion-text-wrap">{{ 'ITEMS.CHATS.DELETED_MESSAGE' | translate }}</div>

    } @else {

      <div class="message ion-text-wrap">{{ message }}</div>

    }

  </ion-label>

</ion-item>
